export const SET_LOADING = 'SET_LOADING';
export const LOGOUT = 'LOGOUT';
export const ADMIN_REGISTER = 'ADMIN_REGISTER';
export const SET_USER = 'SET_USER';
export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_COUNTRY = 'GET_COUNTRY';
export const GET_DATA_COUNTS = 'GET_DATA_COUNTS';
export const GET_CUSTOM_DATA_COUNTS = 'GET_CUSTOM_DATA_COUNTS';
export const GET_GOVERNORATE = 'GET_GOVERNORATE';
export const GET_AREA = 'GET_AREA';
export const GET_LANGUAGE_LIST = 'GET_LANGUAGE_LIST';
export const GET_ADDRESS_LIST = 'GET_ADDRESS_LIST';
export const GET_TERMS = 'GET_TERMS';
export const GET_ALL_USER = 'GET_ALL_USER';
export const GET_TAXI_DATA = 'GET_TAXI_DATA';
export const GET_SINGLE_TAXI_OWNER_DATA = 'GET_SINGLE_TAXI_OWNER_DATA';
export const GET_CAR_TOWING_DATA = 'GET_CAR_TOWING_DATA';
export const GET_SINGLE_CAR_TOWING_OWNER_DATA =
  'GET_SINGLE_CAR_TOWING_OWNER_DATA';
export const GET_SPARE_PART_DATA = 'GET_SPARE_PART_DATA';
export const GET_CAR_DEALER_DATA = 'GET_CAR_DEALER_DATA';
export const GET_SINGLE_CAR_DEALER_DATA = 'GET_SINGLE_CAR_DEALER_DATA';
export const GET_CAR_SALE_DATA = 'GET_CAR_SALE_DATAA';
export const GET_SINGLE_CAR_SALE_DATA = 'GET_SINGLE_CAR_SALE_DATA';
export const GET_CAR_RENT_DATA = 'GET_CAR_RENT_DATA';
export const GET_SINGLE_CAR_RENT_DATA = 'GET_SINGLE_CAR_RENT_DATA';
export const GET_SERVICE_FILTER = 'GET_SERVICE_FILTER';
export const GET_GARAGE_DATA = 'GET_GARAGE_DATA';
export const GET_BUSINESS_DATA = 'GET_BUSINESS_DATA';
export const GET_CARBRAND_DATA = 'GET_CARBRAND_DATA';
// export const ADD_NEW_CAR = 'ADD_NEW_CAR';
export const GET_CARBRAND_FILTER = 'GET_CARBRAND_FILTER';
export const GET_ALL_PRODUCT_PARTS_DATA = 'GET_ALL_PRODUCT_PARTS_DATA';
export const GET_SINGLE_PRODUCT_PART_DATA = 'GET_SINGLE_PRODUCT_PART_DATA';
export const GET_ALL_PARTS_DATA = 'GET_ALL_PARTS_DATA';
export const GET_GARAGE_CATEGORY = 'GET_GARAGE_CATEGORY';
export const GET_SINGLE_GARAGE_CATEGORY = 'GET_SINGLE_GARAGE_CATEGORY';
export const UPDATE_GARAGE_CATEGORY = 'UPDATE_GARAGE_CATEGORY';
export const GET_CARMODEL_DATA = 'GET_CARMODEL_DATA';

export const GET_SPARE_PART_CATEGORY = 'GET_SPARE_PART_CATEGORY';
export const GET_SINGLE_CAR_DEALER_CATEGORY = 'GET_SINGLE_CAR_DEALER_CATEGORY';
export const GET_SINGLE_SPARE_PART_CATEGORY = 'GET_SINGLE_SPARE_PART_CATEGORY';
export const GET_SINGLE_CAR_WASH_CATEGORY = 'GET_SINGLE_CAR_WASH_CATEGORY';
export const GET_SINGLE_CAR_INSURANCE_CATEGORY =
  'GET_SINGLE_CAR_INSURANCE_CATEGORY';
export const GET_SINGLE_CAR_PROTECTION_CATEGORY =
  'GET_SINGLE_CAR_PROTECTION_CATEGORY';
export const GET_SINGLE_AIR_CONDITION_CATEGORY =
  'GET_SINGLE_AIR_CONDITION_CATEGORY';
export const GET_SINGLE_DRIVING_SCHOOL_CATEGORY =
  'GET_SINGLE_DRIVING_SCHOOL_CATEGORY';
export const GET_CAR_DEALER_CATEGORY = 'GET_CAR_DEALER_CATEGORY';
export const GET_ADMIN_AREA = 'GET_ADMIN_AREA';
export const GET_ALL_BUSINESS_DATA_LIST = 'GET_ALL_BUSINESS_DATA_LIST';
export const GET_ALL_BUSINESS_CATEGORY = 'GET_ALL_BUSINESS_CATEGORY';
export const GET_SERVICES_DATA = 'GET_SERVICES_DATA';
export const GET_SINGLE_QUICK_SERVICE = 'GET_SINGLE_QUICK_SERVICE';
export const GET_SINGLE_SERVICES_DATA = 'GET_SINGLE_SERVICES_DATA';
export const UPDATE_SERVICES_DATA = 'UPDATE_SERVICES_DATA';
export const ADD_CAR_SERVICES = 'ADD_CAR_SERVICES';
export const ADD_QUICK_SERVICES = 'ADD_QUICK_SERVICES';
export const GET_PACKAGES_LIST = 'GET_PACKAGES_LIST';
export const ADD_PACKAGES_LIST = 'ADD_PACKAGES_LIST';
export const UPDATE_PACKAGES_LIST = 'UPDATE_PACKAGES_LIST';
export const GET_USER_LIST = 'GET_USER_LIST';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const GET_SINGLE_GARAGE_OWNER = 'GET_SINGLE_GARAGE_OWNER';
export const GET_SINGLE_SPARE_PART = 'GET_SINGLE_SPARE_PART';
export const UPDATE_SINGLE_SPARE_PART = 'UPDATE_SINGLE_SPARE_PART';
export const GET_COUNTRIES_LIST = 'GET_COUNTRIES_LIST';
export const GET_CYCLINDER_LIST = 'GET_CYCLINDER_LIST';
export const GET_MODEL_YEAR_LIST = 'GET_MODEL_YEAR_LIST';
export const GET_DOOR_LIST = 'GET_DOOR_LIST';
export const GET_FUEL_TYPE_LIST = 'GET_FUEL_TYPE_LIST';
export const GET_SEATS_LIST = 'GET_SEATS_LIST';
export const GET_COLOR_LIST = 'GET_COLOR_LIST';
export const GET_SAFETY_LIST = 'GET_SAFETY_LIST';
export const GET_SINGLE_SAFETY_LIST = 'GET_SINGLE_SAFETY_LIST';
export const GET_SINGLE_COLOR_LIST = 'GET_SINGLE_COLOR_LIST';
export const GET_SINGLE_SEAT_LIST = 'GET_SINGLE_SEAT_LIST';
export const GET_SINGLE_DOOR_LIST = 'GET_SINGLE_DOOR_LIST';
export const GET_SINGLE_FUEL_TYPE_LIST = 'GET_SINGLE_FUEL_TYPE_LIST';
export const GET_SINGLE_MODEL_YEAR_LIST = 'GET_SINGLE_MODEL_YEAR_LIST';
export const GET_SINGLE_CYCLINDER_LIST = 'GET_SINGLE_CYCLINDER_LIST';
export const GET_COMFORT_LIST = 'GET_COMFORT_LIST';
export const GET_SINGLE_COMFORT_LIST = 'GET_SINGLE_COMFORT_LIST';
export const ADD_COMFORT = 'ADD_COMFORT';
export const ADD_TERMS_AND_CONDITION = 'ADD_TERMS_AND_CONDITION';
export const ADD_FUEL_TYPE = 'ADD_FUEL_TYPE';
export const ADD_MODEL_YEAR = 'ADD_MODEL_YEAR';
export const ADD_CYLINDER = 'ADD_CYLINDER';
export const ADD_COLOR_LIST = 'ADD_COLOR_LIST';
export const ADD_DOOR_LIST = 'ADD_DOOR_LIST';
export const ADD_SEAT_LIST = 'ADD_SEAT_LIST';
export const ADD_SAFETY_LIST = 'ADD_SAFETY_LIST';
export const UPDATE_COMFORT = 'UPDATE_COMFORT';
export const UPDATE_FUEL_TYPE = 'UPDATE_FUEL_TYPE';
export const UPDATE_MODEL_YEAR = 'UPDATE_MODEL_YEAR';
export const UPDATE_CYLINDER = 'UPDATE_CYLINDER';
export const UPDATE_COLOR_LIST = 'UPDATE_COLOR_LIST';
export const UPDATE_DOOR_LIST = 'UPDATE_DOOR_LIST';
export const UPDATE_SEAT_LIST = 'UPDATE_SEAT_LIST';
export const UPDATE_SAFETY_LIST = 'UPDATE_SAFETY_LIST';
export const GET_SINGLE_CAR_BRAND = 'GET_SINGLE_CAR_BRAND';
export const GET_SERVICE_PROVIDER_LIST = 'GET_SERVICE_PROVIDER_LIST';
export const SEND_NOTIFICATION = 'SEND_NOTIFICATION';

export const CONTACT_LIST = 'CONTACT_LIST';
export const SINGLE_AREA = 'SINGLE_AREA';

export const GET_DATEWISE_ORDER = 'GET_DATEWISE_ORDER';
export const GET_SINGLE_CAR_WASH = 'GET_SINGLE_CAR_WASH';
export const GET_SINGLE_CAR_INSURANCE = 'GET_SINGLE_CAR_INSURANCE';
export const GET_SINGLE_DRIVING_SCHOOL = 'GET_SINGLE_DRIVING_SCHOOL';
export const GET_SINGLE_CAR_PROTECTION = 'GET_SINGLE_CAR_PROTECTION';
export const GET_SINGLE_AIR_CONDITIONING = 'GET_SINGLE_AIR_CONDITIONING';
export const GET_SINGLE_QUICK_SERVICE_OWNER = 'GET_SINGLE_QUICK_SERVICE_OWNER';
export const GET_PROFILE_USER = 'GET_PROFILE_USER';
export const GET_USER_SUBS = 'GET_USER_SUBS';
export const GET_USER_CARPOSTS = 'GET_USER_CARPOSTS';
export const GET_LISTING_STATS = 'GET_LISTING_STATS';
export const GET_PLANS_FOR_BUSINESS = 'GET_PLANS_FOR_BUSINESS';
